/* Copyright (c) 2017 Backpack Health LLC */

/* global window */
import React from 'react';
import { FormattedMessage } from 'react-intl';

import './JewelryProviderSummary.scss';

import { SecondaryButton } from '../../../components/buttons/Buttons';
import { ExternalLink } from '../../../components/TextLink';
import { IJewelryProvider } from '../../../../models/JewelryProvider';
import COLORS from '../../../styles/Colors';
import SquareImageIcon from '../../../components/SquareImageIcon';

interface SummaryProps {
  cssColor: string;
  data: IJewelryProvider;
  onRegister(): void;
  isDefaultExpandend: boolean;
  allowPurchase: boolean;
}
interface SummaryState {
  isExpanded: boolean;
}

class JewelryProviderSummary extends React.Component<SummaryProps, SummaryState> {

  state: SummaryState = {
    isExpanded: this.props.isDefaultExpandend,
  };

  toggleExpand = () => {
    if (this.state.isExpanded) { return; }
    this.setState({ isExpanded: true });
  }

  render() {
    const { isExpanded } = this.state;
    const { data, onRegister, cssColor, allowPurchase } = this.props;
    const { company_name, icon, short_description, vendor_url } = data;

    return (
      <div className="cmp-jewelryprovidersummary" onClick={this.toggleExpand} style={{ cursor: isExpanded ? '' : 'pointer' }}>
        <div className="_title font-body font-color-gsDarkest">
          <SquareImageIcon
            src={icon}
            size={40}
            backgroundColor={COLORS.bcBackpackRedBase}
            placeholderText={company_name ? company_name[0] : ''}
            altText="logo"
          />
          {company_name}
        </div>
        <div className="_description">
          {short_description}
        </div>
        {
          isExpanded && (
            <div className="_controls">
              <SecondaryButton className="" onClick={onRegister} style={{ borderColor: cssColor, color: cssColor }}>
                <FormattedMessage id="jewelryProviders.registerMedicalJewelry.button.label" />
              </SecondaryButton>

              {
                allowPurchase && (
                  <ExternalLink className="font-color-gsMedDark" href={vendor_url}>
                    <FormattedMessage id="jewelryProviders.purchaseMedicalJewelry.button.label" />
                  </ExternalLink>
                )
              }

            </div>
          )
        }
      </div>
    );
  }
}

export default JewelryProviderSummary;
